"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ru = _interopRequireDefault(require("./flags/ru.png"));

var _by = _interopRequireDefault(require("./flags/by.png"));

var _ua = _interopRequireDefault(require("./flags/ua.png"));

var _kz = _interopRequireDefault(require("./flags/kz.png"));

var _us = _interopRequireDefault(require("./flags/us.png"));

var _de = _interopRequireDefault(require("./flags/de.png"));

var _uk = _interopRequireDefault(require("./flags/uk.png"));

var _kg = _interopRequireDefault(require("./flags/kg.png"));

var _uz = _interopRequireDefault(require("./flags/uz.png"));

var _cy = _interopRequireDefault(require("./flags/cy.png"));

var _tr = _interopRequireDefault(require("./flags/tr.png"));

var _ae = _interopRequireDefault(require("./flags/ae.png"));

var _tw = _interopRequireDefault(require("./flags/tw.png"));

var _world = _interopRequireDefault(require("./flags/world.png"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var data = [{
  code: '+7',
  icon: _ru.default,
  countryCode: 'ru',
  countryName: 'Russia'
}, {
  code: '+1',
  icon: _us.default,
  countryCode: 'us',
  countryName: 'United States'
}, {
  code: '+7',
  icon: _kz.default,
  countryCode: 'kz',
  countryName: 'Kazakhstan'
}, {
  code: '+380',
  icon: _ua.default,
  countryCode: 'ua',
  countryName: 'Ukraine'
}, {
  code: '+375',
  icon: _by.default,
  countryCode: 'by',
  countryName: 'Belarus'
}, {
  code: '+49',
  icon: _de.default,
  countryCode: 'de',
  countryName: 'Germany'
}, {
  code: '+90',
  icon: _tr.default,
  countryCode: 'tr',
  countryName: 'Turkey'
}, {
  code: '+44',
  icon: _uk.default,
  countryCode: 'uk',
  countryName: 'United Kingdom'
}, {
  code: '+971',
  icon: _ae.default,
  countryCode: 'ae',
  countryName: 'United Arab Emirates'
}, {
  code: '+886',
  icon: _tw.default,
  countryCode: 'tw',
  countryName: 'Taiwan'
}, {
  code: '+998',
  icon: _uz.default,
  countryCode: 'uz',
  countryName: 'Uzbekistan'
}, {
  code: '+357',
  icon: _cy.default,
  countryCode: 'cy',
  countryName: 'Cyprus'
}, {
  code: '+996',
  icon: _kg.default,
  countryCode: 'kg',
  countryName: 'Kirghizia'
}, {
  code: '+',
  icon: _world.default,
  countryCode: 'world',
  countryName: 'Another Country'
}];
var _default = data;
exports.default = _default;